// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"3427f24f","498":"2305571a","513":"8b9cd345","703":"7422a7d6"}[chunkId] + ".chunk.js";
};